import { TableActions } from '@core/components/Table';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { GroupAdd } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useContext } from 'react';
import { FaCloudDownloadAlt, FaPlus } from 'react-icons/fa';
import { ClienteContext } from '../../ClienteContext';
import { clienteModais } from '../modal/clienteModais';

const ClienteFab = ({ onDelete }) => {
  const [, setModal] = useContext(ClienteContext).modal;
  const [search] = useContext(ClienteContext).search;
  const [selecao] = useContext(ClienteContext).selecao;
  const [tipoSelecao] = useContext(ClienteContext).tipoSelecao;
  const [, setClienteAtual] = useContext(ClienteContext).clienteAtual;

  const existeSelecionados = selecao.length > 0 || tipoSelecao !== 'NENHUM';

  const triggerCreate = (modal) => {
    setClienteAtual({});
    setModal(modal);
  };

  const triggerDelete = () => {
    onDelete({ ids: selecao, q: search, tipoSelecao });
  };

  const actions = [
    {
      icon: <DeleteIcon />,
      name: 'delete',
      tooltip: 'Excluir',
      show: permissaoUtils.cliente().excluir && existeSelecionados,
      onClick: triggerDelete,
    },
    {
      icon: <FaPlus />,
      name: 'createCliente',
      tooltip: 'Cadastrar',
      show: permissaoUtils.cliente().cadastrar,
      onClick: () => triggerCreate(clienteModais.cadastroCliente),
    },
    {
      icon: <FaCloudDownloadAlt />,
      name: 'createImportarCliente',
      tooltip: 'Importar planilha',
      show: permissaoUtils.cliente().cadastrar,
      onClick: () => triggerCreate(clienteModais.importarCliente),
    },
    {
      icon: <GroupAdd />,
      name: 'createGrupoCliente',
      tooltip: 'Cadastrar grupo de clientes',
      show: permissaoUtils.cliente().cadastrar,
      onClick: () => triggerCreate(clienteModais.cadastroGrupoCliente),
    },
  ];

  return <TableActions className={'stepPlusButton'} actions={actions} />;
};

export default ClienteFab;
